import { Organization } from './organization.type'
import { Role } from './role.type'

export enum UserStatus {
  Draft = 'draft',
  Active = 'active',
  Blocked = 'blocked',
  Pending = 'pending',
}

export enum UserGroup {
  General = 'general',
  Internal = 'internal',
  TestFeature = 'test_feature',
  Basic = 'basic',
  StorageUse = 'storage_use',
}

export type AccountType = 'internal' | 'demo' | 'eds' | 'api' | 'customer'

export type User = {
  id: string
  email: string
  name: string
  provider: string
  status: UserStatus
  group: UserGroup
  confirmed_at: string
  organization: Organization
  organization_id?: string
  earnings_management_onboarding: boolean | string | null
  need_password_change: boolean
  subscribed_sectors: string[]
  free_trial_end_at: string
  roles?: Role[]
  profile_access_verified_at?: string
  language?: string
  need_additional_info?: boolean
  need_investment_profile?: boolean
  has_product_updates?: boolean
  has_unread_product_updates?: boolean
  // Analytics label the server derives; set on the Amplitude profile at login.
  account_type?: AccountType
}

export type InvitedUser = {
  email: string
}

export type VerifyEmailResult = 'already' | 'expired' | 'success' | 'invalid'

export type SignInFormData = {
  email: string
  password: string
}

export type CheckSsoFormData = {
  email: string
}

export type SignInWithCodeData = {
  code: string | string[]
}

export type CreateUserFormData = {
  first_name: string
  last_name: string
  email: string
  password: string
  password_confirmation: string
  invitation_token?: string
  country_code: string
  phone_number: string
}

export type AdditionalUserFormData = {
  first_name: string
  last_name: string
  country_code: string
  phone_number: string
  email: string
}

export type VerifyEmailParams = {
  confirmation_token: string
}

export type ForgotPasswordFormData = {
  email: string
}

export type VerifyResetPasswordParams = {
  reset_password_token: string
}

export type ResetPasswordParams = {
  reset_password_token: string
  password: string
  password_confirmation: string
}

export interface ChangePasswordParams {
  current_password: string
  new_password: string
  new_password_confirmation: string
}

export type SetInitialPasswordParams = {
  password: string
  password_confirmation: string
}

export type VerifyInvitationParams = {
  invitation_token: string
}

export type InvitationParams = {
  invitation_token: string
  password: string
  password_confirmation: string
}

export type UpdateUserFormData = {
  name?: string
  first_name?: string
  last_name?: string
  company?: string
  title?: string
  location?: string
  phone?: string
  email?: string
  ingest_data_sources?: string[]
}

export type ResearchUserFormData = {
  name: string
  company: string
  job_title: string
  interest: string
  company_text_ratio: string
}

export type GoogleUserFormData = {
  code: string
  invitation_token: string
}

export type CognitoUserFormData = {
  code: string
  organization_id: string
}

export type VerifyInvitationTokenParams = {
  token: string
}

export type UpdateUserParams = {
  id: string
  group?: UserGroup
}

export type UpdateUserRoleAccessParams = {
  user_id: string
  role_name: string
}

export enum UserRoleAccessResponse {
  Success = 'success',
  Forbidden = 'forbidden',
  IncorrectRole = 'incorrect_role',
  SampleRole = 'sample_role',
  UserNotExists = 'user_not_exists',
  AtLeastOneOwner = 'at_least_one_owner',
  SelfRoleChange = 'self_role_change',
}

export type VerifyProfileAccessTokenParams = {
  token: string
}
